import { useQuery, useMutation } from "@tanstack/react-query";
import { apiGet, apiPost } from "../client";

/**
 * Hook to get consultant account data
 */
export function useConsultantAccount(userId: string, include?: string[], onError?: (errorCode: string) => void) {
	const { data, ...rest } = useQuery<any>({
		queryKey: ["consultant-account", userId],
		queryFn: () =>
			apiGet<any>(`/consultant-account/${userId}`, {
				include: include && include.length ? include.join() : "",
			}),
		onError: (error: any) => {
			const errorCode = error?.response?.data?.code || error?.message || "UNKNOWN_ERROR";
			if (onError) {
				onError(errorCode);
			}
		},
	});

	return {
		consultantAccount: data,
		...rest,
	};
}

/**
 * Hook to submit a consultant rating
 */
export function useConsultantRating(userId?: string, onSuccess?: () => void, onError?: (errorCode: string) => void) {
	if (!userId) return { isLoading: false, mutate: undefined };

	return useMutation({
		mutationFn: (ratingData: any) => apiPost(`/consultant-account/${userId}/rating`, ratingData),
		onSuccess,
		onError: (error: any) => {
			const errorCode = error?.response?.data?.code || error?.message || "UNKNOWN_ERROR";
			if (onError) {
				onError(errorCode);
			}
		},
	});
}
